<script>
    let commitment = 'yes'; // Default value for commitment
    let commitmentExplanation = ''; // Variable to hold the textarea value
    let isExplanationRequired = false;

    // Reactive statement to update the requirement of the explanation
    $: isExplanationRequired = commitment !== 'yes';
</script>

<div class="container">
    <img src="../images/logos/full-color.svg" width="177px" alt="FWF Logo"><br><br><br>
    <h1>This is a Test</h1>
    <h2>We can put anything we want here, and make this font any font type or size.</h2>
<form name="teacherInstituteApplication" method="POST" data-netlify="true">

    <fieldset>
        <legend>Personal Information</legend>
        <label>First Name: <input type="text" name="firstName" required></label><br>
        <label>Last Name: <input type="text" name="lastName" required></label><br>
        <label for="teacherPhoto">Upload a Photo of Yourself (Please no group photos):</label>
        <input type="file" name="teacherPhoto" accept="image/png, image/jpeg" required><br>
        <label>Cell Phone Number: <input type="tel" name="cellPhone" required></label><br>
        <label>Personal Email Address: <input type="email" name="email" required></label><br>
        <label>Street Address: <input type="text" name="streetAddress" required></label><br>
        <label>City: <input type="text" name="city" required></label><br>
        <label>State: <input type="text" name="state" required></label><br>
        <label>ZIP Code: <input type="text" name="zipCode" required></label><br>
    </fieldset>

    <fieldset>
        <legend>Professional Information</legend>
        <label>Job Title: <input type="text" name="jobTitle" required></label><br>
        <label>School District Name: <input type="text" name="schoolDistrict" required></label><br>
        <label>School Mailing Address: <input type="text" name="schoolAddress" required></label><br>
        <label>Principal's Name: <input type="text" name="principalsName" required></label><br>
        <label>Which Grade Level Do You Teach? 
            <select name="educationLevel" required>
                <option value="pre_tk">Pre/T-K</option>
                <option value="elementary">Elementary</option>
                <option value="middle_school">Middle School</option>
                <option value="high_school">High School</option>
                <option value="higher_education">Higher Education</option>
            </select>
        </label><br>
    </fieldset>

    <fieldset>
        <legend>Referral Information</legend>
        <label>How did you learn about the teacher institute? If referred, what is their name?
            <textarea name="referralInfo" required></textarea>
        </label><br>
    </fieldset>

    <fieldset>
        <legend>About Yourself</legend>
        <label>Tell us a little about yourself and your familiarity with Freedom Writers Foundation: 
            <textarea name="aboutYourself" required></textarea>
        </label><br>
    </fieldset>
    <fieldset>
            <legend>Commitment</legend>
            <label>Can you commit to the 5 days?</label><br>
            <div class="radio-buttons">
                <label class="radio-container">Yes
                    <input type="radio" bind:group={commitment} value="yes" required>
                    <span class="checkmark"></span>
                </label>
                <label class="radio-container">No
                    <input type="radio" bind:group={commitment} value="no" required>
                    <span class="checkmark"></span>
                </label>
                <label class="radio-container">Maybe
                    <input type="radio" bind:group={commitment} value="maybe" required>
                    <span class="checkmark"></span>
                </label>
            </div>
            <label>If you selected "no" or "maybe", please provide a brief explanation:
                <textarea name="commitmentExplanation" bind:value={commitmentExplanation} required={isExplanationRequired}></textarea>
            </label><br>
        </fieldset>

    <div class="button-container">
        <button type="submit">Submit Application</button>
    </div>

</form>
</div>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');

.container {
    margin: 0 1rem;
    text-align: center;
}

img {
    padding-top: 3rem;
}

html, body {
  font-family: Roboto;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff; /* FWF background color */
}

form {
  text-align: left;
  width: 95%;
  margin: auto;
  padding: 20px;
  border-radius: 8px;
  background-color: #ffffff; /* FWF background color for the form */
  border: 0px solid #f7931e; /* FWF brand orange for form border */
}

fieldset {
  background-color: #FEF5EB; /* A lighter shade for the fieldset that contrasts with white */
  border: 1px solid #f7931e; /* FWF brand orange for fieldset border */
  border-radius: 8px;
  padding: 10px;
  margin: 10px;
}

legend {
  color: #f7931e; /* FWF brand orange for legend text */
  font-weight: bold; /* Optional: if you want the legend to be bold */
}

input, select, textarea {
  width: 100%;
  padding: 12px;
  margin: 8px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

button {
  width: auto;
  padding: 12px;
  margin: 8px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.button-container {
  text-align: center; /* This will center the button inside the div */
}

button {
  padding: 12px 24px; /* Adjust padding as needed */
  /* The rest of your button styles */
}

input[type="submit"], button {
  background-color: #f7931e; /* FWF brand orange for submit button */
  color: white;
  border: none;
  cursor: pointer;
}

input[type="submit"]:hover, button:hover {
  background-color: #e5821d; /* A darker shade of FWF brand orange for hover effect */
}

label {
  color: #000000; /* Black text for better readability */
  display: block;
  margin-bottom: 5px;
}

  /* Styles for radio buttons */
  .radio-buttons {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
  }

  .radio-container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    align-items: center;
  }

  /* Hide the browser's default radio button */
  .radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #fff;
    border-radius: 50%;
    border: 2px solid #f7931e;
  }

  /* On mouse-over, add a grey background color */
  .radio-container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the radio button is checked, add a blue background */
  .radio-container input:checked ~ .checkmark {
    background-color: #2196F3;
    border: 0px solid #f7931e;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  .radio-container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  .radio-container .checkmark:after {
    top: 9px;
    left: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
</style>
